var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash-es';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'nexe... Remove this comment to see the full error message
import { biz } from 'nexedu-common';
import { DivisionService, ViewService, TeacherService, DateService } from '../../services';
import { DetailView, ExamValidator, CrudService } from '../../interfaces';
import { AppToastrService } from '../../services/app-toastr.service';
var ExamComponent = /** @class */ (function (_super) {
    __extends(ExamComponent, _super);
    function ExamComponent(viewService, divisionService, route, teacherService, dateService, apptoastrService) {
        var _this = _super.call(this, viewService, new ExamWrapperService(divisionService), route, 'topic', ExamValidator.newFormGroup()) || this;
        _this.teacherService = teacherService;
        _this.dateService = dateService;
        _this.apptoastrService = apptoastrService;
        _this.isAssessmentAllowed = false;
        _this.options.populate = {
            'recipients.reference': 'name'
        };
        return _this;
    }
    ExamComponent.prototype.dateChanged = function () {
        // FIXME, this shouldn't be needed
        // We need to mark the control as touched manually with the datePicker PopUp. Otherwise, errors regarding the date
        // will not be shown unless the user manually changes the html input field
        this.form.controls.date.markAsTouched();
    };
    ExamComponent.prototype.onParamsChange = function (params) {
        var _this = this;
        this.isLoading = true;
        this.divisionId = params.divisionId;
        this.service.id = params.divisionId; // set the division id for the wrapper service
        var operation;
        var usr = this.viewService.getCurrentUser();
        if (usr.currentRole === biz.ROLES.TEACHER) {
            operation = this.teacherService.getSubjectsForDivision(usr._id, this.divisionId);
        }
        else {
            operation = Observable.of({ list: [] }); // empty response with no subjects
        }
        operation.finally(function () { _this.isLoading = false; })
            .subscribe(function (result) {
            _this.subjects = result.list;
            if (_this.subjects == null) {
                _this.apptoastrService.errorT("El docente no tiene asignaturas asignadas para crear el examen");
            }
            // only after subjects are returned we can continue with the detail-view machinery
            _super.prototype.onParamsChange.call(_this, params);
        }, function (err) {
            _this.isLoading = false;
            _this.viewService.handleError(err);
        });
    };
    ExamComponent.prototype.getValue = function () {
        return this.form.value;
    };
    ExamComponent.prototype.getDefaultDetails = function () {
        return {
            allowMessages: false,
            division: this.divisionId,
            time: {
                hour: 8,
                minutes: 0
            }
        };
    };
    // @ts-expect-error ts-migrate(2366) FIXME: Function lacks ending return statement and return ... Remove this comment to see the full error message
    ExamComponent.prototype.getDetailsFromParams = function (params) {
        if (!this.isCreate) {
            return {
                _id: params.id,
                allowMessages: false,
                division: params.divisionId
            };
        }
    };
    ExamComponent.prototype.onModelLoaded = function (model) {
        if (this.isCreate) {
            model.subject = model.subject || this.subjects && this.subjects[0] && this.subjects[0]._id;
        }
    };
    // @ts-expect-error ts-migrate(6133) FIXME: 't' is declared but its value is never read.
    ExamComponent.prototype.onSaved = function (t) {
        this.viewService.goBack();
    };
    ExamComponent.prototype.checkPermissions = function () {
        _super.prototype.checkPermissions.call(this);
        if (!this.isCreate) {
            var isPastExam = this.dateService.isPast(this.model.date);
            var subject = _.find(this.subjects, { _id: this.model.subject });
            // check if it's a future exam and subject is assigned to the current user
            this.isSaveAllowed = this.isSaveAllowed && !isPastExam && !!subject;
            this.isDeleteAllowed = this.isDeleteAllowed && !isPastExam && !!subject;
            this.isAssessmentAllowed = isPastExam && !!subject;
        }
    };
    return ExamComponent;
}(DetailView));
export { ExamComponent };
var ExamWrapperService = /** @class */ (function (_super) {
    __extends(ExamWrapperService, _super);
    function ExamWrapperService(service, id) {
        var _this = 
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 3 arguments, but got 2.
        _super.call(this, null, '') || this;
        _this.service = service;
        _this.id = id;
        return _this;
    }
    ExamWrapperService.prototype.getById = function (id, params) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        return this.service.getExamById(this.id, id, params);
    };
    ExamWrapperService.prototype.create = function (object) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        return this.service.addExam(this.id, object);
    };
    ExamWrapperService.prototype.update = function (id, object) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        return this.service.updateExam(this.id, id, object);
    };
    ExamWrapperService.prototype.remove = function (id) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        return this.service.removeExam(this.id, id);
    };
    return ExamWrapperService;
}(CrudService));
